/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_No_ServicesInputs */

const vi_carrier_form_no_services = /** @type {(inputs: Carrier_Form_No_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãng không có dịch vụ khả dụng cho địa chỉ này`)
};

/**

* @param {Carrier_Form_No_ServicesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_no_services = /** @type {((inputs?: Carrier_Form_No_ServicesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_No_ServicesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_no_services(inputs)
});